import {
  AppBar,
  Tabs as UnstyledTabs,
  Toolbar as UnstyledToolbar,
  styled,
} from "@mui/material";
import { NavLink } from "react-router";

import { NavTab } from "@citrine/atoms/tabs";

export const Navbar = styled(AppBar)(({ theme }) => ({
  // ensure the top navbar remains above the project-toolbar
  zIndex: theme.zIndex.appBar + 1,
}));

export const Label = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(0, 5),
}));

export const Logo = styled(NavLink)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: "100%",
  "& img": {
    width: theme.spacing(12.5),
  },
}));

export const Toolbar = styled(UnstyledToolbar)(({ theme }) => ({
  backgroundColor: theme.palette.grey[900],
  gap: theme.spacing(4),
  height: theme.spacing(theme.layout.NAVBAR_HEIGHT),
}));

export const Tab = styled(NavTab)(({ theme }) => ({
  color: theme.palette.common.white,
  opacity: 1,
  height: theme.spacing(theme.layout.NAVBAR_HEIGHT),
  display: "flex",
  alignItems: "center",
  fontSize: theme.spacing(1.875),
  fontWeight: 400,
  letterSpacing: "1.5px",
  margin: 0,
  minWidth: 0,
  padding: 0,
  "::after": {
    background: "none",
  },
  // since the selected Tab has to be styled as root.selected (for component isolation),
  // this must also have root.selected nesting to match precedence
  // see src/contexts/theme/components/tab.ts
  "&.Mui-selected": {
    color: theme.palette.common.white,
    cursor: "pointer",
    fontWeight: 800,
  },
}));

export const Tabs = styled(UnstyledTabs)({
  flexShrink: 0,

  "& .MuiTabs-flexContainer": {
    justifyContent: "flex-end",
  },
  "& .MuiTabs-indicator": {
    display: "none",
  },
});

export const ProjectToolbar = styled(AppBar)(({ theme }) => ({
  top: theme.spacing(theme.layout.NAVBAR_HEIGHT),
}));
